import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "notification", "item", "emptyMessage"]
  static values = {
    notificationDuration: { type: Number, default: 3000 }
  }

  connect() {
    document.addEventListener("cart:updated", this.handleCartUpdate.bind(this))
  }

  disconnect() {
    document.removeEventListener("cart:updated", this.handleCartUpdate.bind(this))
  }

  handleCartUpdate(event) {
    this.updateCart(event.detail.count)
  }

  async add(event) {
    event.preventDefault()
    const productId = event.currentTarget.dataset.productId

    try {
      const response = await fetch("/cart_items", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]").content
        },
        body: JSON.stringify({ product_id: productId })
      })

      const data = await response.json()
      this.updateCart(data.cart_count)
      this.showNotification(data.message, data.status)
    } catch (error) {
      console.error("Error:", error)
      this.showNotification("Error adding item to cart", "error")
    }
  }

  async remove(event) {
    event.preventDefault()
    const itemId = event.currentTarget.dataset.itemId
    const itemElement = event.currentTarget.closest("[data-cart-target=\"item\"]")


    try {
      const response = await fetch(`/cart_items/${itemId}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]").content
        }
      })

      const data = await response.json()
      this.updateCart(data.cart_count)

      // Remove the item from DOM with a fade out effect
      itemElement.style.transition = "opacity 0.3s ease-out"
      itemElement.style.opacity = "0"

      setTimeout(() => {
        itemElement.remove()

        // Show empty message if no items left
        if (this.itemTargets.length === 0 && this.hasEmptyMessageTarget) {
          this.emptyMessageTarget.classList.remove("hidden")
        }
      }, 300)

      this.showNotification(data.message, data.status)
    } catch (error) {
      console.error("Error:", error)
      this.showNotification("Error removing item from cart", "error")
    }
  }

  updateCart(cart_count) {
    if (this.hasCountTarget) {
      if (cart_count === 0) {
        this.countTarget.classList.add("hidden")
      } else {
        this.countTarget.classList.remove("hidden")
      }
      this.countTarget.textContent = cart_count
    }
  }

  showNotification(message, status = "success") {
    const notification = document.createElement("div")

    // Define colors for different status types
    const statusClasses = {
      success: "bg-trina-green-100",
      error: "bg-red-500",
      info: "bg-trina-yellow-100"
    }

    notification.className = `fixed top-4 right-4 px-4 py-2 rounded shadow-lg ${
      statusClasses[status] || statusClasses.success
    } text-white`
    notification.textContent = message
    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, this.notificationDurationValue)
  }

}
